/* eslint-disable no-undef */
/* eslint-disable wrap-iife */
/* eslint-disable no-magic-numbers */
/* eslint-disable max-statements */
/* eslint-disable no-invalid-this */

( function( $ ) {

	$(document).on( 'nfFormReady', function() {
		console.log('Form is ready');

        $(document).on('focus', '#nf-field-1-wrap', function() {
			$(this).addClass('is-active');
		});
		$(document).on('focusout', '#nf-field-1-wrap', function() {
			$(this).removeClass('is-active');
		});
		$(document).on('blur', '#nf-field-1-wrap', function() {
			if ($('input.ninja-forms-field').val().length > 0) {
				$(this).addClass('is-active');
			}
			else {
				$(this).removeClass('is-active');
			}
		});
        
        $(document).on('focus', '#nf-field-2-wrap', function() {
			$(this).addClass('is-active');
		});
		$(document).on('focusout', '#nf-field-2-wrap', function() {
			$(this).removeClass('is-active');
		});
		$(document).on('blur', '#nf-field-2-wrap', function() {
			if ($('#nf-field-2').val().length > 0) {
				$(this).addClass('is-active');
			}
			else {
				$(this).removeClass('is-active');
			}
		});
        
        $(document).on('focus', '#nf-field-3-wrap', function() {
			$(this).addClass('is-active');
		});
		$(document).on('focusout', '#nf-field-3-wrap', function() {
			$(this).removeClass('is-active');
		});
		$(document).on('blur', '#nf-field-3-wrap', function() {
			if ($('textarea.ninja-forms-field').val().length > 0) {
				$(this).addClass('is-active');
			}
			else {
				$(this).removeClass('is-active');
			}
		});

		// $(document).on('focus', '#nf-field-2-wrap', function() {
		// 	$(this).addClass('is-active');
		// });
		// $(document).on('focusout', '#nf-field-2-wrap', function() {
		// 	$(this).removeClass('is-active');
		// });
		// $(document).on('blur', '#nf-field-2-wrap', function() {
		// 	if ($('.ninja-forms-field').val().length > 0) {
		// 		$(this).addClass('is-active');
		// 	}
		// 	else {
		// 		$(this).removeClass('is-active');
		// 	}
		// });

		// $(document).on('focus', '#nf-field-3-wrap', function() {
		// 	$(this).addClass('is-active');
		// });
		// $(document).on('focusout', '#nf-field-3-wrap', function() {
		// 	$(this).removeClass('is-active');
		// });
		// $('.ninja-forms-field').on('blur', function() {
		// 	if ($('.ninja-forms-field').val().length > 0) {
		// 		$(this).addClass('is-active');
		// 	}
		// 	else {
		// 		$(this).removeClass('is-active');
		// 	}
        // });


	});
} )( jQuery );



// WEBPACK FOOTER //
// ./src/js/inc/form.js